import netsGreetingsNew from './nets-greetings-new';
import moduleConfig from './module-config';

export default angular
  .module('app.greetings-new', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsGreetingsNew', netsGreetingsNew);
